export { TooltipContainerComponent } from './tooltip-container.component';
export { TooltipDirective } from './tooltip.directive';
export { TooltipModule } from './tooltip.module';
export { TooltipConfig } from './tooltip.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/tooltip/index.js
// module id = 1067
// module chunks = 8